import PageWrapper from '../common/layouts/PageWrapper';
import { PageTitle } from '../common/constants/features-constants';
import FaqAccordionsAch from '../common/components/ach-account/FaqAccordionsAch';

export const ACHAccount = () => (
  <PageWrapper title={PageTitle.ACH_ACCOUNTS} headTitle={PageTitle.ACH_ACCOUNTS}>
    <FaqAccordionsAch />
  </PageWrapper>
);
